export function NotFound() {
  return (
    <section className="wrap-s center section">
      <h1>404</h1>
      <p className="soft">This page could not be found.</p>
      <p><a className="btn" href="/">Back home</a></p>
    </section>
  );
}
